// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"613":"075dcce6","5850":"a7aca8a4"}[chunkId] + ".chunk.css";
};